module.exports = "/static/media/lineto-circular-medium.764604c6.woff2";